<template>
  <section>
    <div class="flex justify-between">
      <div>
        <h1 class="text-title-3 text-neutral-100">
          {{ t('upload.tip') }}
        </h1>
        <!--  <p class="text-pararaphy-2 text-neutral-70">
          Extensões permitidas: (.pdf .doc .jpg .jpeg .png .bmp)
        </p> -->
        <!-- <p class="text-pararaphy-2 text-neutral-70">
          Tamanho máximo do arquivo: 2GB
        </p> -->
      </div>
      <q-icon
        size="2.5rem"
        name="svguse:#icon_cloud_file"
        class="text-neutral-60"
      />
    </div>

    <div class="mt-24">
      <FilePondInput
        v-if="!loading.upload"
        ref="filePondInputRef"
        :url="`${URLS.arquivos}`"
        :row-id="row.id"
        :files="files"
        :on-data="onData"
        :on-revert="onRevert"
        :on-click-file="onClickFile"
        :label-idle="t('upload.click')"
      />
      <BaseLoader v-else class="h-[200px] grid place-items-center" />
    </div>
  </section>
</template>

<script setup>
import { arquivosService } from 'js/vue/services/arquivos.service'
import { errorDefault } from 'js/utils/error'
import { is } from 'quasar'
import { onMounted, ref, toRaw } from 'vue'
import { URLS } from 'js/modules/axios'
import { useI18n } from 'vue-i18n'
import BaseLoader from 'components/Loader/BaseLoader.vue'
import FilePondInput from 'components/Upload/FilePondInput.vue'

const { t } = useI18n()

const { row } = defineProps({
  row: {
    type: Object,
    default: () => ({}),
  },
})

const loading = ref({ upload: true })

const { getArquivos, deleteArquivo } = arquivosService()

function onData(formData) {
  formData.append('solicitacao_arquivo', row.id)
  return formData
}

async function onRevert(jsonString) {
  const isNumber = is.number(jsonString)
  const json = isNumber ? jsonString : JSON.parse(jsonString)
  const id = isNumber ? jsonString : json.id
  if (id) {
    try {
      await deleteArquivo(id)
    } catch (error) {
      errorDefault(t('error.file'))
    }
  }
}

const filePondInputRef = ref(null)
const files = ref(null)

const getFiles = async () => {
  const { results } = await getArquivos(`?solicitacao_arquivo=${row.id}`)
  return results.map((i) => ({
    ...i,
    source: i.id,
    options: {
      type: 'limbo',
      file: {
        url: i.arquivo,
        ...i.detalhes,
      },
    },
  }))
}

// Exemplo de uso:
function onClickFile(e, pond) {
  // window._big('clicou')
  // console.log('clicou')
  // const isNumber = is.number(e.detail.file.serverId)
  // const json = isNumber
  //   ? e.detail.file.serverId
  //   : JSON.parse(e.detail.file.serverId)
  // const id = isNumber ? json : json.id
  // const file = pond.files.find((i) => i.id === id)
  // console.log({
  //   id,
  //   json,
  //   isNumber,
  //   file,
  //   files: e.detail.pond.files.get(),
  // })
  // downloadFile(file.arquivo, file.detalhes.name)
}
// defineExpose({ pond })
onMounted(async () => {
  loading.value.upload = true
  files.value = await getFiles()
  loading.value.upload = false
})
</script>
